import { useEffect, useContext } from 'react'
import GameContext from './GameContext'

export default (): void => {
  const {
    iconFoundList,
    difficulty,
    setIsShowingWinModal,
    setIsPaused,
    onPauseTimer,
    isCheckWin,
  } = useContext(GameContext)

  useEffect(() => {
    if (isCheckWin && iconFoundList.length === difficulty) {
      setIsShowingWinModal(true)
      setIsPaused(true)
      onPauseTimer()
    }
  }, [
    difficulty,
    iconFoundList.length,
    onPauseTimer,
    setIsPaused,
    setIsShowingWinModal,
  ])
}
